import customerFragment from '~/server/utils/magento-queries/customer.fragment'

export default `
  query customer {
    customer {
      ${customerFragment}
    }
  }
`
